import { useQuery } from '@tanstack/react-query';

import { toastError } from 'common/toast';
import { fetchFilesPiiOptions } from 'api/files';

import { APIKeys } from 'common/enum/api-keys.enum';
import { FilesPiiOptions } from 'common/types/files-pii-options.type';

export const useFilesPiiOptions = () => {
  const { data, refetch, isFetching } = useQuery<FilesPiiOptions>({
    gcTime: Infinity,
    staleTime: Infinity,
    queryFn: () => fetchData(),
    queryKey: [APIKeys.FILES_PII_OPTIONS],
  });

  const fetchData = async (): Promise<FilesPiiOptions> => {
    try {
      const { data } = await fetchFilesPiiOptions();

      return data;
    } catch (error) {
      toastError('Failed to fetch files pii options', error);

      throw error;
    }
  };

  return {
    data,
    refetch: refetch,
    isLoading: isFetching,
  };
};
